interface QuoteSummaryProps {
  serviceName: string;
  propertyType: string;
  frequency: string;
  surfaceArea: number;
  rooms: number;
  bathrooms: number;
  basePrice: number;
  frequencyMultiplier: number;
  totalPrice: number;
}

export default function QuoteSummary({
  serviceName,
  propertyType,
  frequency,
  surfaceArea,
  rooms,
  bathrooms,
  basePrice,
  frequencyMultiplier,
  totalPrice
}: QuoteSummaryProps) {
  const formatCHF = (amount: number): string => {
    return `CHF ${amount.toLocaleString('fr-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  return (
    <div className="bg-surface rounded-lg p-6 border border-border">
      <h3 className="text-xl font-heading font-bold text-foreground mb-6">Résumé du devis</h3>
      
      <div className="space-y-4 mb-6">
        <div className="flex justify-between items-start">
          <span className="text-sm text-muted-foreground">Service</span>
          <span className="text-sm font-heading font-medium text-foreground text-right">{serviceName}</span>
        </div>
        
        <div className="flex justify-between items-start">
          <span className="text-sm text-muted-foreground">Type de propriété</span>
          <span className="text-sm font-heading font-medium text-foreground">{propertyType}</span>
        </div>
        
        <div className="flex justify-between items-start">
          <span className="text-sm text-muted-foreground">Fréquence</span>
          <span className="text-sm font-heading font-medium text-foreground">{frequency}</span>
        </div>
        
        <div className="h-px bg-border" />
        
        <div className="flex justify-between items-start">
          <span className="text-sm text-muted-foreground">Surface</span>
          <span className="text-sm font-heading font-medium text-foreground">{surfaceArea} m²</span>
        </div>
        
        <div className="flex justify-between items-start">
          <span className="text-sm text-muted-foreground">Pièces</span>
          <span className="text-sm font-heading font-medium text-foreground">{rooms}</span>
        </div>
        
        <div className="flex justify-between items-start">
          <span className="text-sm text-muted-foreground">Salles de bain</span>
          <span className="text-sm font-heading font-medium text-foreground">{bathrooms}</span>
        </div>
        
        <div className="h-px bg-border" />
        
        <div className="flex justify-between items-start">
          <span className="text-sm text-muted-foreground">Prix de base</span>
          <span className="text-sm font-heading font-medium text-foreground">{formatCHF(basePrice)}</span>
        </div>
        
        {frequencyMultiplier !== 1 && (
          <div className="flex justify-between items-start">
            <span className="text-sm text-muted-foreground">Réduction fréquence</span>
            <span className="text-sm font-heading font-medium text-success">
              -{((1 - frequencyMultiplier) * 100).toFixed(0)}%
            </span>
          </div>
        )}
      </div>
      
      <div className="pt-4 border-t-2 border-primary">
        <div className="flex justify-between items-center">
          <span className="text-lg font-heading font-bold text-foreground">Total estimé</span>
          <span className="text-2xl font-heading font-bold text-primary">{formatCHF(totalPrice)}</span>
        </div>
        <p className="text-xs text-muted-foreground mt-2">
          *Prix indicatif. Devis final après visite sur place.
        </p>
      </div>
    </div>
  );
}